<template>
  <span
    class="inline-block animate-spin rounded-full border-6 border-current border-t-transparent align-middle"
    :style="{ width: sizePx, height: sizePx, color: resolvedColor }"
    role="progressbar"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { resolveThemeColor } from './themeColor'

/** UiProgressCircular — Vuetify <v-progress-circular> replacement. */
const props = withDefaults(
  defineProps<{
    size?: number
    color?: string
    indeterminate?: boolean
  }>(),
  { size: 70, color: 'lightBlue', indeterminate: true },
)

const sizePx = computed(() => `${props.size}px`)
const resolvedColor = computed(() => resolveThemeColor(props.color))
</script>
